import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/Utils/services/app.service';
import { common } from 'src/app/app.common';
import { Router } from '@angular/router';
import { ResponseGetInfo } from 'src/app/Models/output.model/ResponseGetInfo';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Profile } from 'src/app/Utils/services/Profile.service';
import { ResponseBase } from 'src/app/Models/output.model/ResponseBase';
import { ProfileService } from 'src/app/Utils/service/profile.service';
import { RequestBase } from 'src/app/Models/input.model/RequestBase';
import { AppConfiguration, AppConfig } from 'src/configuration';
import { Injectable, Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  Token: any;
  HelpLink: any;
  constructor(
    @Inject(AppConfig) 
    private readonly appConfig: AppConfiguration,
    public AppService: AppService,
    private toastr: ToastrService,
    public router: Router,
    public ProfileServirce: Profile,
    public ProfileServirces: ProfileService
  ) { }
  public com: common;
  public UserForm: FormGroup;
  public GetInfoResult: ResponseGetInfo;
  public ResBase: ResponseBase;
  public ReqBase: RequestBase =new RequestBase();
  public Response: ResponseGetInfo;
  Title: string="Đang tải thông tin..."
  TitleClass: string="spinner-border text-muted"
  ngOnInit() {
    this.UserForm = new FormGroup({
      Ho_ten: new FormControl(null),
      Ma_cb: new FormControl(null),
      Ngay_sinh: new FormControl(null),
      So_dien_thoai: new FormControl(null, Validators.nullValidator),
      Email: new FormControl(null, Validators.nullValidator),
      Dia_chi_lien_he: new FormControl(null, Validators.nullValidator),
    });
    this.com = new common(this.router);
    this.com.CheckLogin();
    this.GetInfoResult = new ResponseGetInfo()
    this.ResBase = new ResponseBase()
    this.getData();
  }

  help() {
    const urlHelp = this.appConfig.HelpUrl+"?"+this.appConfig.document_ho_so_ca_nhan;
    window.open(urlHelp,'_blank');
  }

  SetData(m) {
    this.UserForm.controls.Ho_ten.setValue(m.Ho_ten)
    this.UserForm.controls.Ma_cb.setValue(m.Ma_cb)
    this.UserForm.controls.Ngay_sinh.setValue(m.Ngay_sinh)
    this.UserForm.controls.So_dien_thoai.setValue(m.So_dien_thoai)
    this.UserForm.controls.Email.setValue(m.Email)
    this.UserForm.controls.Dia_chi_lien_he.setValue(m.Dia_chi_lien_he)
  }
  UpdateInfo() {
    var a = this.com.getUserinfo();
    this.ProfileServirces.UpdateInfo(a.Info.UserName, a.Token, this.ResBase, this.UserForm.value)
    .subscribe(z => {
      this.Response = z
      if (this.Response.Status == 1) {
        this.toastr.success( 'Cập nhật thành công');
      }
      else {
        this.toastr.error(this.Response.Message, 'Thao tác thất bại');
      }
    },
    (err) =>{
       this.toastr.warning(this.getServerErrorMessage(err));
    });
  }

   getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 401: {
        return `Bạn không có quyền thực hiện chức năng này!`;
        }
        case 404: {
            return `Not Found: ${error.message}`;
        }
        case 403: {
            return `Access Denied: ${error.message}`;
        }
        case 500: {
            return `Internal Server Error: ${error.message}`;
        }
        default: {
            return `Server Error: ${error.message}`;
        }
    }
}

  getData() {
    var a = this.com.getUserinfo();
    this.ReqBase.UserName=a.Info.UserName
   this.GetInfo(this.ReqBase,a.Token)
  }
  GetInfo(req: RequestBase, token) {
    this.ProfileServirces.GetInfo(req, token)
    .subscribe(z => {
      this.Response = z
      if (this.Response.Status == 1) {
        this.Title="Thông tin cá nhân"
        this.TitleClass=""
       this.SetData(this.Response.Data);
      }
      else {
        this.toastr.error(this.Response.Message, 'Thao tác thất bại');
      }
    },
    errors =>{
      this.toastr.error(this.getServerErrorMessage(errors));
      this.AppService.logout();
    });
  }
}
